import React, { useState } from 'react'
import Button from '../button/index'
import { InputLabel, TextAreaLabel } from '../fields/index'
import { Row, Col } from '../grid/index'
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11'
import { ContactForm } from './style'
import Loader from '../loader/index'
import Alert from '../alert/index'
import globals from '../globals'

const Form = props => {

  const [ phone, setPhone ] = useState('')
  const [ isSubmitting, setSubmitting] = useState(false)
  const [ alertData, updateAlert ] = useState({})
  const { register, handleSubmit, errors } = useForm({
    mode: 'onBlur',
  });

  const updateAndHideAlert = object => {
    updateAlert({
      visible: true,
      type: 'success',
      message: 'Mensagem enviada com sucesso.'
    });

    setTimeout( () => {
      updateAlert({});
    }, 4000)
  }

  const onSubmit = data => {
    setSubmitting(true)

    const postObject = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${btoa('1:1')}`
      },
      body: JSON.stringify(data)
    }

    const ErroGenerico = 'Ocorreu algum erro. Tente novamente mais tarde.'

    fetch(`${globals.externals.slim}/marketing/contato/ficaazul`, postObject)
      .then( r => r.json() )
      .then( data => {
        const isSuccess = data.status === "sucesso"
        const type = isSuccess ? 'success' : 'error'
        const message = isSuccess ? 'Email enviado com sucesso!' : ErroGenerico
        setSubmitting(false)
        updateAndHideAlert({
          visible: true,
          type,
          message
        });
        console.log(data) 
      })
      .catch( err => {
        setSubmitting(false)
        updateAndHideAlert({
          type: 'error',
          visible: true,
          message: ErroGenerico
        });
        console.log('Erro', err) 
      })

    // fake ajax
    setTimeout(() => {
      setSubmitting(false)
      updateAndHideAlert({
        visible: true,
        type: 'success',
        message: 'Mensagem enviada com sucesso.'
      });
    }, 3000);
  }

  return (
    <ContactForm onSubmit={handleSubmit(onSubmit)}>
      <Loader isActive={isSubmitting}>Enviando...</Loader>
      <Row gutter={15}>
        <Col>
          <Alert info={alertData} />
        </Col>
        <InputLabel 
          label="Nome"
          name="nome"
          forwardRef={register({ 
            required: "Preencha seu nome",
            minLength: { value: 3, message: "Digite um nome válido "}
          })}
          errors={errors}
          responsive={{
            medium: 6
          }}
          // span={ 6 } 
          />

        <InputLabel 
          label="Nome da Imobiliária"
          name="nomeImobiliaria"
          forwardRef={register}
          errors={errors}
          responsive={{
            medium: 6
          }}
          />

        <InputLabel 
          label="Email"
          name="email"
          htmlType="email"
          forwardRef={register({ 
            required: "Preencha seu email",
            pattern: { 
              value: /^(([^<>()[\]\\.,;:\s@."]+(\.[^<>()[\]\\.,;:\s@."]+)*)|(.".+."))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 
              message: "Digite um email válido."
            }
          })}
          errors={errors}
          responsive={{
            medium: 6
          }}
          />

        <InputLabel
          name="telefone"
          label="Telefone"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          htmlType="tel"
          mask={'(99) 99999-9999'}
          forwardRef={register({ 
            required: "Preencha seu telefone" ,
            pattern: {
              value: /^\(\d{2}\) (9|)\d{4}-\d{4}$/,
              message: "Digite um telefone válido"
            }
          })}
          errors={errors}
          responsive={{
            medium: 6
          }}
          />

        <TextAreaLabel
          label="Mensagem"
          name="mensagem"
          forwardRef={register({ 
            required: 'Campo obrigatório' 
          })}
          errors={errors}
          />

        <Col>
          <Button htmlType="submit" type="primary">Enviar</Button>    
        </Col>
      </Row>
      
      
    </ContactForm>
  )
}

export default Form